import { BaseModel } from './base.model';

import { UserModel } from './user.model';
import { ActionPlanModel } from './action-plan.model';

export class ActionPlanResponseModel extends BaseModel {
    who: number | null;
    action_plan_id: number | null;

    why: string;
    how: string;
    what: string;
    where_at: string;
    quantity: string;
    observation: string;

    when: Date | any;

    user: UserModel | null;
    action_plan: ActionPlanModel | null;

    attachments?;

    constructor(actionPlan: Partial<ActionPlanResponseModel>) {
        super();

        this.who = actionPlan && actionPlan.who || null;
        this.action_plan_id = actionPlan && actionPlan.action_plan_id || null;
        
        this.how = actionPlan && actionPlan.how || "";
        this.why = actionPlan && actionPlan.why || "";
        this.what = actionPlan && actionPlan.what || "";
        this.where_at = actionPlan && actionPlan.where_at || "";
        this.quantity = actionPlan && actionPlan.quantity || "";
        this.observation = actionPlan && actionPlan.observation || "";
    
        this.when = actionPlan && actionPlan.when || new Date();

        this.user = actionPlan && actionPlan.user || null;
        this.action_plan = actionPlan && actionPlan.action_plan || null;

        this.attachments = actionPlan && actionPlan.attachments || null;
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/action-plan-response.model.ts